import { CheckBadgeIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import CertificationCard from './CertificationCard';

const CertificationsSection = () => {
  const certifications = [
    {
      name: 'ISO Certified',
      description: 'Our products meet the highest international standards for quality and safety.',
      icon: <ShieldCheckIcon className="h-12 w-12 text-primary" />,
      image: './apex-logo.webp'
    },
    {
      name: 'Halal Certified',
      description: 'We adhere to strict guidelines ensuring all our products meet Halal requirements.',
      icon: <CheckBadgeIcon className="h-12 w-12 text-text-primary" />,
      image: './halal.png'
    },
    {
      name: 'Global Recycled Standard',
      description: 'We comply with rigorous standards to ensure our products contain verified recycled materials and meet environmental and social criteria.',
      icon: <CheckBadgeIcon className="h-12 w-12 text-text-primary" />,
      image: './grs.webp'
    },
    {
      name: 'ISO 9001:2015',
      description: 'We adhere to the ISO 9001:2015 standard for quality management systems, ensuring consistent product quality, continuous improvement, and customer satisfaction.',
      icon: <CheckBadgeIcon className="h-12 w-12 text-text-primary" />,
      image: './ISO_9001.webp'
    },
    {
      name: 'ISO 22000:2018',
      description: 'We follow the ISO 22000:2018 food safety management standard to ensure safe food handling practices across the supply chain, from production to delivery.',
      icon: <CheckBadgeIcon className="h-12 w-12 text-text-primary" />,
      image: './ISO_22000.webp'
    }
    
    
  ];

  return (
    <section id='certifications' className="bg-secondary py-16">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
      <h3 className="text-text-primary text-lg font-semibold text-center mb-2">Certifications</h3>
    <h2 className="text-3xl text-primary font-bold text-center mb-4">Our Commitment to Quality and Safety</h2>
    <p className="text-text-primary text-center mb-6">
    We proudly hold certifications that ensure our commitment to quality and safety across all products and services.
    </p>
        <div className="flex flex-wrap justify-center">
          {certifications.map((cert, index) => (
            <CertificationCard key={cert + index} certifications={cert} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
